<template>
  <el-descriptions :column="column" :direction="direction" :border="border" :label-style="labelStyle" :size="size">
      <el-descriptions-item
        v-for="(item,index) in data"
        :key="index"
        :label="item[descriptionsProps.label]"
        :span="item.span"
        >
        <!-- content 为字段的释义， label 为字段名 -->
        <!-- 有字段释义的都以问号形式体现 -->
        <template v-if="item[descriptionsProps.content] !== null" slot="label">
          {{ item[descriptionsProps.value] }}
          <el-tooltip v-if="item[descriptionsProps.content]"  class="item" effect="dark" :content="item[descriptionsProps.content]" placement="top-start">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <span>{{ item[descriptionsProps.label] }}</span>
        </template>
      </el-descriptions-item>
  </el-descriptions>
</template>
<script>

export default {
  name: 'DescriptionsList',
  components: {},
  props: {
    direction: {
      type: String,
      default: 'horizontal',
    },
    column: {
      type: Number,
      default: 1,
    },
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    border: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
    descriptionsProps: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value',
          content: 'content',
        }
      },
    },
    labelStyle: {
      type: Object,
      default: () => {
        return {
          width: '150px',
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>

</style>

